import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBAnimation} from 'mdbreact';

class AvianFluTesting extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
      }

  render() {
    return (
        <div>
                <div className="pb-3 blog-margin-adjustment-desktop">
                <MDBAnimation type="fadeIn">
                    <div>
                        <img src={'https://lotus-pet-foods.s3.us-west-1.amazonaws.com/Landing+Page/mainbannerLV1.jpg'} 
                        className="banner img-fluid w-100" 
                        alt="All lotus raw has tested negative for avian flu (H5N1)"/>
                    </div>
                </MDBAnimation>
                </div>
       
            <div className='container mt-5'>
                <p style={{"color": "grey"}}>Apr 12, 2025</p>
            </div>

            <div className='container mt-5 text-center d-none-mobile'>
                <h1><span className="LemonMilkbold-font blog-hb">Avian Flu Testing</span></h1>
            </div>

            <div className='container mt-5 text-center d-none-desktop'>
                <h1><span className="LemonMilkbold-font blog-h">Avian Flu Testing</span></h1>
            </div>
  
            <div className='container' style={{"marginTop": "60px"}}>
                <div className='mb-5 futura-font blog-p'>                    
                    <MDBRow className="d-flex justify-content-center align-items-center mt-5">
                        <MDBCol xs="12" sm="12" md="6" className=" justify-content-center ">                            
                            <div className="futura-bold-font blog-h-color">
                                <h3>Owner :</h3>
                            </div>
                            <p>NOT SPECIFIED</p>
                            <br />
                            <br />
                            <div className="futura-bold-font blog-h-color">
                                <h3>Rdvm :</h3>
                            </div>
                            <p>NOT SPECIFIED</p>
                            <br />
                            <br />
                            <div className="futura-bold-font blog-h-color">
                                <h3>Clinic :</h3>
                            </div>
                            <p>LOTUS PET FOODS</p>
                            <br />
                            <br />

                        </MDBCol>
                        <MDBCol xs="12" sm="12" md="6" className="px-5 py-4">                        
                            <div className="futura-font blog-p">
                                <ul>
                                    <li><b>Accession Number: </b> D25-017346</li>                                    
                                    <li><b>Case Coordinator: </b> MOLECULAR LAB</li>                                    
                                    <li><b>Received: </b>03/14/2025</li>                                    
                                    <li><b>Finalized: </b>PENDING</li>
                                    <li><b>Species: </b>NOT APPLICABLE</li>
                                    <li><b>Specimen: </b>RAW ANIMAL FOOD</li>                                    
                                </ul>
                            </div>
                        </MDBCol>
                    </MDBRow>
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>
    );
  }
}

export default AvianFluTesting;